import React from 'react'
import { Button } from 'react-bootstrap'
import useClientLocation from '../../../hooks/use-client-location'

const EditButton = ({
    userId,
    ...props
}) => {
    const { toUserGoal } = useClientLocation()

    return (
        <React.Fragment>
            <Button onClick={() => toUserGoal(userId)} {...props} />
        </React.Fragment>
    )
}

export default EditButton